export default "__VITE_ASSET__CvZLVMdj__"